import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => (
  <div className="admin-page-stack">
    <section className="admin-section-card">
      <p className="admin-section-eyebrow">404</p>
      <h1>Pagina nao encontrada</h1>
      <p>Volte para o overview administrativo para continuar a operacao da plataforma.</p>
      <Link to="/overview" className="admin-primary-button admin-primary-button--inline">
        Ir para overview
      </Link>
    </section>
  </div>
);

export default NotFoundPage;